export const getIntlData = (obj, locale) => {
  const defaultLocale = "pt";
  if (!obj) {
    return;
  }

  return obj[locale] ? obj[locale] : obj[defaultLocale];
};
